var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgAvatar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0398 14.1208C13.4812 14.1208 15.6165 15.1708 16.7778 16.7375L15.5498 17.3181C14.6045 16.1981 12.9378 15.4541 11.0398 15.4541C9.14182 15.4541 7.47516 16.1981 6.52982 17.3181L5.30249 16.7368C6.46382 15.1701 8.59849 14.1208 11.0398 14.1208ZM11.0398 4.12079C11.9239 4.12079 12.7717 4.47198 13.3968 5.0971C14.022 5.72222 14.3732 6.57007 14.3732 7.45412V9.45412C14.3731 10.3131 14.0415 11.1389 13.4474 11.7593C12.8533 12.3797 12.0427 12.7468 11.1845 12.7841L11.0398 12.7875C10.1558 12.7875 9.30792 12.4363 8.6828 11.8111C8.05768 11.186 7.70649 10.3382 7.70649 9.45412V7.45412C7.70654 6.59515 8.03818 5.76935 8.63226 5.14894C9.22634 4.52853 10.037 4.1614 10.8952 4.12412L11.0398 4.12079ZM11.0398 5.45412C10.5297 5.45409 10.0388 5.64901 9.66765 5.99898C9.29649 6.34895 9.07309 6.82753 9.04316 7.33679L9.03982 7.45412V9.45412C9.03932 9.97473 9.24184 10.475 9.60434 10.8487C9.96684 11.2223 10.4608 11.4399 10.9811 11.4552C11.5015 11.4705 12.0073 11.2822 12.3911 10.9305C12.7749 10.5787 13.0065 10.0912 13.0365 9.57146L13.0398 9.45412V7.45412C13.0398 6.92369 12.8291 6.41498 12.454 6.03991C12.079 5.66484 11.5703 5.45412 11.0398 5.45412Z"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgAvatar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/avatar.664fc7c4349f17bcdfd2ba7b53e57a06.svg";